import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FileText, ExternalLink, ArrowRight, 
  Search, AlertCircle, Loader2, FileDown 
} from 'lucide-react';
import './PdfList.css';

const PdfList = ({ darkMode }) => {
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPdfs = async () => {
      try {
        const lesson_id = localStorage.getItem('lesson_id') ;
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/pdfs/lesson/${lesson_id}`);
        setPdfs(response.data.pdfs || []);
      } catch (error) {
        console.error("Error fetching PDFs", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPdfs();
  }, []);

  // تصفية الملفات بناءً على البحث
  const filteredPdfs = pdfs.filter(pdf => 
    pdf.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`pdf-page-container ${darkMode ? 'dark-mode' : ''}`}>
      <div className="pdf-content-wrapper">
        
        {/* Header Section */}
        <header className="pdf-header">
          <motion.button 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="back-nav-btn" 
            onClick={() => navigate('/Video')}
          >
            <ArrowRight size={20} />
            <span>الرجوع للفيديو</span>
          </motion.button>

          <div className="header-text">
            <motion.h1 
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
            >
              المكتبة <span className="highlight">الرقمية</span>
            </motion.h1>
            <p>جميع الملحقات والملفات الخاصة بالمادة العلمية</p>
          </div>
        </header>

        {/* Search Bar */}
        <div className="search-section">
          <div className="search-box">
            <Search className="search-icon" size={20} />
            <input 
              type="text" 
              placeholder="ابحث عن اسم الملف أو المذكرة..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* List Logic */}
        {loading ? (
          <div className="pdf-state-view">
            <Loader2 className="spinner" size={48} />
            <p>جاري تحضير الملفات لك...</p>
          </div>
        ) : filteredPdfs.length === 0 ? (
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="pdf-state-view empty"
          >
            <AlertCircle size={64} />
            <h3>لا توجد ملفات حالياً</h3>
            <p>يبدو أنه لا توجد ملفات مطابقة لبحثك أو لم يتم رفع ملفات بعد.</p>
          </motion.div>
        ) : (
          <div className="pdf-grid">
            <AnimatePresence>
              {filteredPdfs.map((pdf, index) => (
                <motion.div 
                  key={pdf.id}
                  layout
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="pdf-card"
                >
                  <div className="pdf-icon-wrapper">
                    <FileText size={32} />
                  </div>
                  
                  <div className="pdf-info">
                    <h3>{pdf.title}</h3>
                    <p>{pdf.description || "لا يوجد وصف متاح لهذا الملف."}</p>
                  </div>

                  <div className="pdf-actions">
                    <a 
                      href={pdf.FullSrc} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="view-btn"
                    >
                      <ExternalLink size={18} />
                      عرض
                    </a>
                    <a 
                      href={pdf.FullSrc} 
                      download 
                      className="download-btn-icon"
                      title="تحميل الملف"
                    >
                      <FileDown size={20} />
                    </a>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfList;